module.exports = __webpack_public_path__ + "img/explainer-dashboard.f31149e4.jpg";